import { render } from "./AccountLinkingPage.vue?vue&type=template&id=f669641e"
import script from "./AccountLinkingPage.vue?vue&type=script&lang=js"
export * from "./AccountLinkingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__